import { RegisterActorForm } from "Auth/Components/RegisterActorForm";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";

export const RegisterActorPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <UnauthenticatedLayout title={t(Resources.RegisterActor.Title)}>
      <RegisterActorForm />
    </UnauthenticatedLayout>
  );
};
